export default __webpack_public_path__ + "static/media/slimmom.c3f6ff4b.jpg";